module.exports = __webpack_public_path__ + "img/bianla-popup.0dedd26e.png";